module.exports = "pegasus/assets/themelp1/small/0.png";